import React, { useMemo } from "react";
import { useToggle } from "react-use";
import { ChainUploadFileProps } from "./servers";
import Style from "./index.module.scss";
import ListItem from "./Components/ListItem";
import { Modal } from "antd";
import useUploadGen from "../../utils/v2/useUploadGen";
import FileSelect from "./Components/FileSelect";

interface Props {
    children?: React.ReactChild;
    buttonClass?: string;
    buttonText?: string;
    onUploadSuccess: (files: ChainUploadFileProps[]) => void;
    onCancel: () => void;
    tokenUrl: string;
    uploadUrl: string;
    multiple?: boolean;
    type?: Record<string, string[]>;
}
const Index = ({
    children,
    onUploadSuccess,
    onCancel,
    tokenUrl,
    uploadUrl,
    type,
    ...restProps
}: Props) => {
    const { cancel, onFileChange, uploadLoading, fileList } = useUploadGen({
        nextType: type,
        tokenUrl
    });

    const [show, toggleShow] = useToggle(false);

    function onFinish() {
        onUploadSuccess(fileList);
        toggleShow(false);
    }

    function cancelUpload() {
        toggleShow(false);
        cancel("STOP");
        onCancel();
    }

    const disabled = useMemo(() => {
        return !fileList.some(i => i.status === "done");
    }, [fileList]);

    function selectOk(files: File[]) {
        onFileChange(files);
        toggleShow(true);
    }

    return (
        <div>
            <FileSelect
                loading={uploadLoading}
                buttonClass={Style.fileBtn}
                buttonText="本地上传文件"
                onFileSelect={selectOk}
            />

            <Modal
                title="文件上传"
                visible={show}
                width={700}
                onOk={onFinish}
                okButtonProps={{ disabled }}
                onCancel={cancelUpload}>
                <div className={Style.modal}>
                    <div className={Style.main}>
                        <div className={Style.upList}>
                            {Array.from(fileList).map((item: any) => {
                                return <ListItem key={item.uid} file={item} />;
                            })}
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default Index;
